export default __webpack_public_path__ + "ab355abb2fc85a52afc9dbe165f6ff1d.svg";